import styled from "styled-components";

export const TextTermsArea = styled.div`
  margin-bottom: 16px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding: 16px;
  height: 400px;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: #f5f5f5;
`;

export const TextTermosTitle = styled.h2`
  font-size: 17px;
  margin-top: 10px;
`;

export const TextTermos = styled.p`
  font-size: 14px;
  margin-bottom: 10px;
`;
